<template>
  <div :style="altoAncho" id="mapa" class="mapa"></div>
</template>

<script>
export default {
  name: "Mapa",
  props: {
    msg: String,
    datosGeoJson: Array,
    altoAncho: String,
    datosaddGeoJon: Array
  },
  data: function() {
    return {
      mapa: null,
      geoJson: null,
      eventoLayer: null
    };
  },
  watch: {
    datosaddGeoJon: function(val) {
     /*  try { */
        this.geoJson.clearLayers();
        this.geoJson.addData(val);
        this.eventoLayer.openPopup();
      this.mapa.panTo(this.eventoLayer.getLatLng());
    /*   } catch (e) {
        console.log(e);
      } */
    }
  },
  created() {
    var style = document.createElement("link");
    style.setAttribute("rel", "stylesheet");
    style.setAttribute(
      "href",
      "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
    );

    document.head.appendChild(style);
    style.addEventListener("load", () => {});

    var script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute(
      "src",
      "https://unpkg.com/leaflet@1.6.0/dist/leaflet.js"
    );
    document.head.appendChild(script);
    script.addEventListener("load", () => {
      this.mapa = L.map("mapa", {
        minZoom: 3,
        maxZoom: 18,
        center: [-9.94318, -76.02824],
        zoom: 5
      });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.mapa);
      this.geoJson = L.geoJSON(false, {
        onEachFeature: (feature, layer) => {
          var proper = feature.properties;
          var popPup = "";
          if (proper.type == "events") {
            popPup += "Magnitud: " + "M" + proper.magn + "<br>";
            popPup += "Profundidad: " + proper.prof + "Km." + "<br>";
            popPup += "<b>Fecha: " + proper.date + "</b>";
            layer.bindPopup(popPup);
            this.eventoLayer = layer;
          }
          if (proper.type == "stations") {
            popPup += "<b>Estacion:</b> " + proper.nom + "<br>";
            popPup += "<b>Codigo:</b> " + proper.cod;
            layer.bindPopup(popPup);
          }
         /*  if (!this.geoJson.getLayers().length) {
            
          } */
        },
        pointToLayer: function(feature, latlng) {
          let mag = parseFloat(feature.properties.prof);
          var proper = feature.properties;
          let icon = "";

          if (mag < 60) {
            icon = `${process.env.VUE_APP_PUBLIC_PATH}/images/superficial.webp`;
          }
          if (mag >= 60 && mag < 300) {
            icon = `${process.env.VUE_APP_PUBLIC_PATH}/images/intermedio.webp`;
          }
          if (mag > 300) {
            icon = `${process.env.VUE_APP_PUBLIC_PATH}/images/profundo.webp`;
          }
          var myIcon = L.icon({
            iconUrl: icon,
            iconAnchor: [8, 8],
            iconSize: [16, 16],
            popupAnchor: [-1, -30]
          });
          if (proper.type == "stations") {
            myIcon.options.popupAnchor = [0, -25];
            myIcon.options.iconAnchor = [4, 4];
            myIcon.options.iconSize = [16, 16];
            myIcon.options.iconUrl = `${process.env.VUE_APP_PUBLIC_PATH}/images/estacion.webp`;
          }
          return L.marker(latlng, { icon: myIcon });
        }
      }).addTo(this.mapa);

      L.Control.Watermark = L.Control.extend({
        onAdd: function() {
          var img = L.DomUtil.create("img");

          img.src = `https://www.igp.gob.pe/programas-de-investigacion/images/logo_igp_small.png`;
          img.style.width = "100px";
          img.style.opacity = 0.8;

          return img;
        },
        onRemove: function() {}
      });
      L.control.watermark = function(opts) {
        return new L.Control.Watermark(opts);
      };

      L.control.watermark({ position: "bottomleft" }).addTo(this.mapa);

      this.geoJson.addData(this.datosGeoJson);
      this.eventoLayer.openPopup();

      this.mapa.panTo(this.eventoLayer.getLatLng());
      this.geoJson.addData(this.datosaddGeoJon);


    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
